module.exports = __webpack_public_path__ + "public/static/img/undraw_dashboard_nklg_2.32096b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_dashboard_nklg_2.svg
// module id = uj7+
// module chunks = 1